import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { BaseAPIService } from '@app/Services/api.base.service';
import { label } from '@app/constants/labels';


@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.scss']
})
export class TermsComponent {

  termsandcondition: boolean = false;
  privacyandpolicy: boolean = false;
  labels = label;
  constructor(public activeModal: NgbActiveModal, public auth: AuthenticationService, private readonly baseService: BaseAPIService) { }

  public DeclineTerms() {
    this.auth.isTermsAccepted = false;
    this.auth.logout();
  }
  public AcceptTerms() {
    this.baseService.PatchWithHeaders('/User/UpdateTermAccepted', {}, {}).subscribe((result: Boolean) => {
      this.auth.isTermsAccepted = true;
      this.activeModal.close('Close click');
      this.auth.UpdateRbacDetails(this.auth.context);
    });
  }
}
